import { parse } from 'tldts'
import type { Team } from '@dashboard/types/team'
import { useDomainNameStore } from '@dashboard/modules/settings/stores/domainNameStore'
export const domainNameForWebsite = (website?: string | null) => (website ? parse(website).domain : null)

export const domainNameForTeam = (team: Team) => {
  const { domains } = useDomainNameStore()

  return [...domains, team.website]
    .map((d) => {
      if (!d) {
        return null
      }

      return domainNameForWebsite(d)
    })
    .find((d) => d)
}
